import React, { useState, useEffect, useMemo } from "react";
import Select from "react-select";
import { Global } from "../helpers/Global";
import {
  MapContainer,
  TileLayer,
  Marker,
  useMapEvents,
  LayersControl,
} from "react-leaflet";
import "leaflet/dist/leaflet.css";
import L from "leaflet";
import { GeoSearchControl, OpenStreetMapProvider } from "leaflet-geosearch";
import "leaflet-geosearch/dist/geosearch.css";

delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: require("leaflet/dist/images/marker-icon-2x.png"),
  iconUrl: require("leaflet/dist/images/marker-icon.png"),
  shadowUrl: require("leaflet/dist/images/marker-shadow.png"),
});

export const ClientesAdmin = () => {
  const [clientes, setClientes] = useState([]);
  const [lugares, setLugares] = useState([]);
  const [mostrarCentrosDeCliente, setMostrarCentrosDeCliente] = useState(null);

  // Modal centro
  const [mostrarModal, setMostrarModal] = useState(false);
  const [clienteSeleccionado, setClienteSeleccionado] = useState(null);
  const [nuevoLugar, setNuevoLugar] = useState("");
  const [latitud, setLatitud] = useState(null);
  const [longitud, setLongitud] = useState(null);
  const [permiteJornadas, setPermiteJornadas] = useState(false);
  const [error, setError] = useState("");
  const [modoEdicion, setModoEdicion] = useState(false);
  const [centroEditandoId, setCentroEditandoId] = useState(null);
  const [ubicacionInicial, setUbicacionInicial] = useState([40.4168, -3.7038]);

  // Modal cliente
  const [modalEditarCliente, setModalEditarCliente] = useState(false);
  const [clienteEditando, setClienteEditando] = useState(null);
  const [editNombre, setEditNombre] = useState("");
  const [editCodigo, setEditCodigo] = useState("");

  // Filtros vista
  const [mostrarClientesDesactivados, setMostrarClientesDesactivados] = useState(false);
  const [mostrarCentrosDesactivados, setMostrarCentrosDesactivados] = useState(false);

  // 👥 Modal RESPONSABLES
  const [mostrarModalResp, setMostrarModalResp] = useState(false);
  const [centroResp, setCentroResp] = useState(null);
  const [responsables, setResponsables] = useState([]);
  const [usuarios, setUsuarios] = useState([]);
  const [respSeleccion, setRespSeleccion] = useState(null); // <- una sola opción
  const [respCargando, setRespCargando] = useState(false);
  const [respMsg, setRespMsg] = useState("");
  const [respOrden, setRespOrden] = useState({ campo: "nombre", ascendente: true });

  useEffect(() => {
    navigator.geolocation.getCurrentPosition(
      (pos) => setUbicacionInicial([pos.coords.latitude, pos.coords.longitude]),
      () => console.warn("No se pudo obtener la ubicación. Se usa Madrid.")
    );
  }, []);

  useEffect(() => {
    fetchClientes();
    fetchCentros();
  }, []);

  const CenterMapOnCoords = ({ lat, lng }) => {
    const map = useMapEvents({});
    useEffect(() => {
      if (lat && lng) map.setView([lat, lng]);
    }, [lat, lng, map]);
    return null;
  };

  const authHeaders = () => ({
    Authorization: `Bearer ${localStorage.getItem("token")}`,
    "Content-Type": "application/json",
  });

  const fetchClientes = async () => {
    try {
      const res = await fetch(Global.url + "clientes/todos", {
        headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
      });
      setClientes(await res.json());
    } catch (error) {
      console.error("Error al obtener clientes:", error);
    }
  };

  const fetchCentros = async () => {
    try {
      const res = await fetch(Global.url + "centros/todos", {
        headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
      });
      setLugares(await res.json());
    } catch (error) {
      console.error("Error al obtener centros:", error);
    }
  };

  const toggleCentros = (clienteId) => {
    setMostrarCentrosDeCliente((prev) => (prev === clienteId ? null : clienteId));
  };

  const eliminarCentro = async (centroId) => {
    if (!window.confirm("¿Eliminar este centro?")) return;
    try {
      const res = await fetch(`${Global.url}centros/${centroId}`, {
        method: "DELETE",
        headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
      });
      if (res.ok) {
        setLugares((prev) => prev.filter((l) => l.id !== centroId));
        alert("Centro eliminado.");
      }
    } catch {
      alert("Error al eliminar centro.");
    }
  };

  const abrirModalAgregarCentro = (clienteId) => {
    setClienteSeleccionado(clienteId);
    setNuevoLugar("");
    setLatitud(null);
    setLongitud(null);
    setPermiteJornadas(false);
    setCentroEditandoId(null);
    setModoEdicion(false);
    setMostrarModal(true);
  };

  const abrirModalEditarCentro = (centro) => {
    setClienteSeleccionado(centro.cliente_id);
    setNuevoLugar(centro.nombre);
    const lat = centro.latitud !== null ? parseFloat(centro.latitud) : null;
    const lng = centro.longitud !== null ? parseFloat(centro.longitud) : null;
    setLatitud(lat);
    setLongitud(lng);
    setPermiteJornadas(centro.permite_jornadas);
    setCentroEditandoId(centro.id);
    setModoEdicion(true);
    if (lat && lng) setUbicacionInicial([lat, lng]);
    setMostrarModal(true);
  };

  const cerrarModalAgregarCentro = () => {
    setMostrarModal(false);
    setNuevoLugar("");
    setLatitud(null);
    setLongitud(null);
    setPermiteJornadas(false);
    setCentroEditandoId(null);
    setModoEdicion(false);
    setError("");
  };

  const guardarCentro = async (e) => {
    e.preventDefault();
    if (!latitud || !longitud) {
      setError("Selecciona una ubicación válida en el mapa.");
      return;
    }

    const payload = {
      cliente_id: clienteSeleccionado,
      nombre: nuevoLugar,
      latitud,
      longitud,
      permite_jornadas: permiteJornadas,
    };

    const url = modoEdicion ? `${Global.url}centros/${centroEditandoId}` : `${Global.url}centros`;
    const method = modoEdicion ? "PUT" : "POST";

    try {
      const res = await fetch(url, {
        method,
        headers: authHeaders(),
        body: JSON.stringify(payload),
      });
      if (res.ok) {
        await fetchCentros();
        cerrarModalAgregarCentro();
        alert(modoEdicion ? "Centro actualizado." : "Centro añadido.");
      } else {
        alert("Error al guardar el centro.");
      }
    } catch {
      alert("Error de red al guardar el centro.");
    }
  };

  const abrirModalEditarCliente = (cliente) => {
    setClienteEditando(cliente);
    setEditNombre(cliente.nombre);
    setEditCodigo(cliente.codigo || "");
    setModalEditarCliente(true);
  };

  const guardarCambiosCliente = async () => {
    try {
      const res = await fetch(`${Global.url}clientes/${clienteEditando.id}`, {
        method: "PUT",
        headers: authHeaders(),
        body: JSON.stringify({ nombre: editNombre, codigo: editCodigo }),
      });
      if (res.ok) {
        await fetchClientes();
        setModalEditarCliente(false);
        setClienteEditando(null);
      } else {
        alert("❌ Error al guardar los cambios");
      }
    } catch (err) {
      console.error("Error al guardar cliente:", err);
      alert("❌ Error de red al guardar");
    }
  };

  const eliminarCliente = async (clienteId) => {
    if (!window.confirm("¿Eliminar este cliente?")) return;
    try {
      const res = await fetch(`${Global.url}clientes/${clienteId}`, {
        method: "DELETE",
        headers: authHeaders(),
      });
      if (res.ok) {
        fetchClientes();
        alert("Cliente eliminado.");
      }
    } catch {
      alert("Error al eliminar cliente.");
    }
  };

  const reactivarCliente = async (clienteId) => {
    if (!window.confirm("¿Reactivar este cliente?")) return;
    try {
      const res = await fetch(`${Global.url}clientes/${clienteId}/reactivar`, {
        method: "PUT",
        headers: authHeaders(),
      });
      if (res.ok) {
        await fetchClientes();
        alert("Cliente reactivado correctamente.");
      } else {
        const data = await res.json();
        alert(data.message || "Error al reactivar el cliente.");
      }
    } catch {
      alert("Error de red al reactivar el cliente.");
    }
  };

  const reactivarCentro = async (centroId) => {
    if (!window.confirm("¿Reactivar este centro?")) return;
    try {
      const res = await fetch(`${Global.url}centros/${centroId}/reactivar`, {
        method: "PUT",
        headers: authHeaders(),
      });
      if (res.ok) {
        fetchCentros();
        alert("Centro reactivado.");
      }
    } catch {
      alert("Error al reactivar centro.");
    }
  };

  // ---------- 👥 RESPONSABLES ----------
  const abrirModalResponsables = async (centro) => {
    setCentroResp(centro);
    setRespMsg("");
    setRespSeleccion(null);
    setMostrarModalResp(true);
    await cargarResponsablesYUsuarios(centro.id);
  };

  const cargarResponsablesYUsuarios = async (centroId) => {
    setRespCargando(true);
    try {
      const [r1, r2] = await Promise.all([
        fetch(`${Global.url}centros/${centroId}/responsables`, { headers: authHeaders() }),
        fetch(`${Global.url}usuarios/todos`, { headers: authHeaders() }), // ajusta si difiere
      ]);
      const resp = await r1.json();
      const usrs = await r2.json();
      setResponsables(Array.isArray(resp) ? resp : []);
      setUsuarios(Array.isArray(usrs) ? usrs.filter((u) => u.activo !== false) : []);
    } catch (e) {
      console.error(e);
      setRespMsg("No se pudieron cargar los datos.");
    } finally {
      setRespCargando(false);
    }
  };

  const quitarResponsable = async (usuarioId) => {
    if (!centroResp) return;
    setRespCargando(true);
    setRespMsg("");
    try {
      const res = await fetch(`${Global.url}centros/${centroResp.id}/responsables/${usuarioId}`, {
        method: "DELETE",
        headers: authHeaders(),
      });
      if (!res.ok) throw new Error("DELETE responsable failed");
      await cargarResponsablesYUsuarios(centroResp.id);
    } catch (e) {
      console.error(e);
      setRespMsg("No se pudo quitar el usuario.");
    } finally {
      setRespCargando(false);
    }
  };

  const agregarResponsable = async () => {
    if (!centroResp || !respSeleccion) return;
    setRespCargando(true);
    setRespMsg("");
    try {
      const id = Number(respSeleccion.value);
      const res = await fetch(`${Global.url}centros/${centroResp.id}/responsables`, {
        method: "POST",
        headers: authHeaders(),
        body: JSON.stringify({ usuarios_id: [id] }),
      });
      if (!res.ok) throw new Error("POST responsables failed");
      await cargarResponsablesYUsuarios(centroResp.id);
      setRespSeleccion(null);
    } catch (e) {
      console.error(e);
      setRespMsg("No se pudo agregar el usuario.");
    } finally {
      setRespCargando(false);
    }
  };

  // Opciones de selector: usuarios NO asignados
  const usuarioOptionsResp = useMemo(() => {
    const idsAsignados = new Set(responsables.map((r) => r.id));
    return (usuarios || [])
      .filter((u) => !idsAsignados.has(u.id))
      .map((u) => ({
        value: String(u.id),
        label: `${u.nombre} ${u.apellidos || ""} (${u.email || u.dni || "s/d"})`.trim(),
      }))
      .sort((a, b) => a.label.localeCompare(b.label));
  }, [usuarios, responsables]);

  const responsablesOrdenados = useMemo(() => {
    const { campo, ascendente } = respOrden;
    const arr = [...(responsables || [])];
    arr.sort((a, b) => {
      const va = (a[campo] ?? "").toString().toLowerCase();
      const vb = (b[campo] ?? "").toString().toLowerCase();
      return ascendente ? va.localeCompare(vb) : vb.localeCompare(va);
    });
    return arr;
  }, [responsables, respOrden]);

  const manejarOrdenResp = (campo) =>
    setRespOrden((prev) => ({ campo, ascendente: prev.campo === campo ? !prev.ascendente : true }));

  const cerrarModalResponsables = () => {
    setMostrarModalResp(false);
    setCentroResp(null);
    setResponsables([]);
    setUsuarios([]);
    setRespSeleccion(null);
    setRespMsg("");
  };
  // ---------- FIN RESPONSABLES ----------

  return (
    <>
      <div className="filtros">
        <label>
          <input
            type="checkbox"
            checked={mostrarClientesDesactivados}
            onChange={(e) => setMostrarClientesDesactivados(e.target.checked)}
          />
          Mostrar clientes desactivados
        </label>
        <label>
          <input
            type="checkbox"
            checked={mostrarCentrosDesactivados}
            onChange={(e) => setMostrarCentrosDesactivados(e.target.checked)}
          />
          Mostrar Centros Desactivados
        </label>
      </div>

      <div className="tabla-clientes">
        <h2>Gestión de Clientes y Centros</h2>
        <table className="tabla-listado-clientes">
          <thead>
            <tr>
              <th>Cliente</th>
              <th>Código</th>
              <th>Acciones</th>
            </tr>
          </thead>

          <tbody>
            {clientes
              .filter((cliente) => cliente.activo || mostrarClientesDesactivados)
              .map((cliente) => (
                <React.Fragment key={cliente.id}>
                  <tr>
                    <td>{cliente.nombre}</td>
                    <td>{cliente.codigo || "-"}</td>
                    <td className="acciones-columna">
                      <button onClick={() => toggleCentros(cliente.id)}>
                        {mostrarCentrosDeCliente === cliente.id ? "Ocultar Centros" : "Mostrar Centros"}
                      </button>
                      <button onClick={() => abrirModalAgregarCentro(cliente.id)}>Añadir Centro</button>
                      <button onClick={() => abrirModalEditarCliente(cliente)}>Editar Cliente</button>
                      {cliente.activo ? (
                        <button onClick={() => eliminarCliente(cliente.id)}>Eliminar</button>
                      ) : (
                        <button onClick={() => reactivarCliente(cliente.id)}>Reactivar</button>
                      )}
                    </td>
                  </tr>

                  {mostrarCentrosDeCliente === cliente.id && (
                    <tr>
                      <td colSpan="3" style={{ padding: 0 }}>
                        <table className="subtabla-centros">
                          <thead>
                            <tr>
                              <th>Centro</th>
                              <th>Jornadas</th>
                              <th>Acciones</th>
                            </tr>
                          </thead>
                          <tbody>
                            {lugares
                              .filter(
                                (centro) =>
                                  centro.cliente_id === cliente.id &&
                                  (mostrarCentrosDesactivados || centro.activo)
                              )
                              .map((centro) => (
                                <tr key={centro.id}>
                                  <td>{centro.nombre}</td>
                                  <td>{centro.permite_jornadas ? "✔" : "✖"}</td>
                                  <td className="acciones-columna">
                                    <button onClick={() => abrirModalEditarCentro(centro)}>Editar</button>
                                    <button onClick={() => abrirModalResponsables(centro)}>Responsables</button>
                                    {centro.activo ? (
                                      <button onClick={() => eliminarCentro(centro.id)}>Eliminar</button>
                                    ) : (
                                      <button onClick={() => reactivarCentro(centro.id)}>Reactivar</button>
                                    )}
                                  </td>
                                </tr>
                              ))}
                          </tbody>
                        </table>
                      </td>
                    </tr>
                  )}
                </React.Fragment>
              ))}
          </tbody>
        </table>

        {/* MODAL: Editar Cliente */}
        {modalEditarCliente && (
          <div className="modal-overlay">
            <div className="modal-content">
              <button className="modal-close" onClick={() => setModalEditarCliente(false)}>&times;</button>
              <h3>Editar Cliente #{clienteEditando?.id}</h3>

              <label>Nombre:</label>
              <input value={editNombre} onChange={(e) => setEditNombre(e.target.value)} />

              <label>Código:</label>
              <input value={editCodigo} onChange={(e) => setEditCodigo(e.target.value)} />

              <button className="btn-login" onClick={guardarCambiosCliente}>💾 Guardar Cambios</button>
            </div>
          </div>
        )}

        {/* MODAL: Crear/Editar Centro */}
        {mostrarModal && (
          <div className="modal-overlay">
            <div className="modal-content">
              <button onClick={cerrarModalAgregarCentro} className="modal-close">&times;</button>
              <h3>{modoEdicion ? "Editar Centro" : "Añadir Centro"}</h3>
              <form onSubmit={guardarCentro}>
                <label>Nombre del Centro:</label>
                <input
                  type="text"
                  value={nuevoLugar}
                  onChange={(e) => setNuevoLugar(e.target.value)}
                  required
                />

                <label>Selecciona ubicación en el mapa o introduce coordenadas:</label>

                <MapContainer center={ubicacionInicial} zoom={15} style={{ height: "350px", width: "100%" }}>
                  <LayersControl position="topright">
                    <LayersControl.BaseLayer checked name="Satélite + Callejero">
                      <TileLayer
                        url={`https://api.maptiler.com/maps/hybrid/256/{z}/{x}/{y}.jpg?key=${process.env.REACT_APP_MAPTILER_KEY}`}
                        attribution="&copy; MapTiler"
                      />
                    </LayersControl.BaseLayer>
                    <LayersControl.BaseLayer name="Callejero">
                      <TileLayer
                        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                        attribution="&copy; OpenStreetMap contributors"
                      />
                    </LayersControl.BaseLayer>
                  </LayersControl>

                  <MapaClick setLatitud={setLatitud} setLongitud={setLongitud} />
                  <SearchControl setLatitud={setLatitud} setLongitud={setLongitud} />
                  <CenterMapOnCoords lat={latitud} lng={longitud} />

                  {latitud && longitud && (
                    <Marker
                      position={[latitud, longitud]}
                      eventHandlers={{ click: () => { setLatitud(null); setLongitud(null); } }}
                    />
                  )}
                </MapContainer>

                <label>Coordenadas (lat, lng):</label>
                <input
                  type="text"
                  value={latitud !== null && longitud !== null ? `${latitud}, ${longitud}` : ""}
                  onChange={(e) => {
                    const [lat, lng] = e.target.value.split(",").map((n) => parseFloat(n.trim()));
                    if (!isNaN(lat) && !isNaN(lng)) { setLatitud(lat); setLongitud(lng); }
                  }}
                  placeholder="Ej: 40.4168, -3.7038"
                />

                <label>
                  <input
                    type="checkbox"
                    checked={permiteJornadas}
                    onChange={(e) => setPermiteJornadas(e.target.checked)}
                  />
                  Este centro permite registrar jornadas
                </label>

                {error && <p className="error">{error}</p>}

                <button type="submit" className="btn-principal">
                  {modoEdicion ? "Guardar Cambios" : "Guardar Centro"}
                </button>
              </form>
            </div>
          </div>
        )}

        {/* 👥 MODAL: RESPONSABLES */}
        {mostrarModalResp && (
          <div className="modal-overlay">
            <div className="modal-content modal-resp">
              <button onClick={cerrarModalResponsables} className="modal-close">&times;</button>
              <h3>Responsables de “{centroResp?.nombre}”</h3>

              {respMsg && <div className="alerta">{respMsg}</div>}

              {/* Selector + acción */}
              <div className="filtros">
                <div className="filtro" style={{ flex: 3 }}>
                  <label>Añadir responsable:</label>
                  <Select
                    isSearchable
                    isClearable
                    classNamePrefix="select"
                    placeholder="Buscar usuario…"
                    options={usuarioOptionsResp}
                    value={respSeleccion}
                    onChange={(opt) => setRespSeleccion(opt || null)}
                    menuPortalTarget={document.body}
                  />
                </div>
                <div className="filtro" style={{ alignSelf: "end" }}>
                  <button
                    className="btn-principal"
                    onClick={agregarResponsable}
                    disabled={respCargando || !respSeleccion}
                  >
                    Añadir
                  </button>
                </div>
              </div>

              {/* Tabla de asignados */}
              <div className="table-listado-padre">
                <table className="table-listado">
                  <thead>
                    <tr>
                        <th className="ordenable" onClick={() => manejarOrdenResp("nombre")}>Nombre</th>
                        <th className="ordenable" onClick={() => manejarOrdenResp("apellidos")}>Apellidos</th>
                        <th className="ordenable" onClick={() => manejarOrdenResp("email")}>Email</th>
                        <th>Acciones</th>
                        <th className="td-invisible"></th>
                    </tr>
                    </thead>
                    <tbody>
                    {respCargando ? (
                        <tr><td colSpan={5}>Cargando…</td></tr>
                    ) : responsablesOrdenados.length === 0 ? (
                        <tr><td colSpan={5} className="muted">No hay responsables asignados.</td></tr>
                    ) : (
                        responsablesOrdenados.map((u) => (
                        <tr key={u.id}>
                            <td>{u.nombre}</td>
                            <td>{u.apellidos || "-"}</td>
                            <td>{u.email || "-"}</td>
                            <td className="botones-usuario">
                            <button className="btn-mapa" onClick={() => quitarResponsable(u.id)}>
                                Quitar
                            </button>
                            </td>
                            <td className="td-invisible"></td>
                        </tr>
                        ))
                    )}
                    </tbody>

                </table>
              </div>

              <div style={{ marginTop: 8, textAlign: "right" }}>
                <span className="muted">
                  {responsables.length} responsable{responsables.length !== 1 ? "s" : ""} asignado{responsables.length !== 1 ? "s" : ""}.
                </span>
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

const MapaClick = ({ setLatitud, setLongitud }) => {
  useMapEvents({
    click(e) {
      setLatitud(e.latlng.lat);
      setLongitud(e.latlng.lng);
    },
  });
  return null;
};

const SearchControl = ({ setLatitud, setLongitud }) => {
  const map = useMapEvents({});
  useEffect(() => {
    const provider = new OpenStreetMapProvider();
    const search = new GeoSearchControl({
      provider,
      style: "bar",
      autoClose: true,
      showMarker: false,
      searchLabel: "Buscar ubicación...",
    });

    map.addControl(search);
    map.on("geosearch/showlocation", (result) => {
      const { x, y } = result.location;
      setLatitud(y);
      setLongitud(x);
    });

    return () => map.removeControl(search);
  }, [map]);

  return null;
};
